import { all_routes } from "../../../feature-module/router/all_routes";
// import { userRole } from "../stored-data";
const routes = all_routes;

// console.log("userData:", userRole)

export const SidebarDataTest = (userRole: string) => {
  // console.log("USERROLE: ", userRole)

  return [
    {
      tittle: "",
      icon: "file",
      showAsTab: false,
      separateRoute: false,
      base: "dashboard",
      submenuItems: [
        ...(userRole === "admin"
          ? AdminSidebarMenu
          : userRole === "manager"
            ? ManagerSidebarMenu
            : userRole === "verifier"
              ? VerifierSidebarMenu
              : []),
      ],
    },
  ];
};

// Admin
const AdminSidebarMenu = [
  // {
  //   label: "Live Case Progress",
  //   link: routes.admin_liveCaseProgress,
  //   submenu: false,
  //   showSubRoute: false,
  //   icon: "activity",
  //   base: "live-track-case",
  //   materialicons: "confirmation_number",
  //   submenuItems: [],
  // },
  {
    label: "HR Action Required",
    link: routes.admin_hrActionRequired,
    submenu: false,
    showSubRoute: false,
    icon: "alert-circle",
    base: "hr-action-required",
    materialicons: "confirmation_number",
    submenuItems: [],
  },
  {
    label: "Candidate Tracking",
    link: routes.admin_case_tracking,
    submenu: false,
    showSubRoute: false,
    icon: "trending-up",
    base: "hr-action-required",
    materialicons: "timeline",
    submenuItems: [],
  },
  {
    label: "Line of Business",
    link: routes.lobList,
    submenu: false,
    showSubRoute: false,
    icon: "briefcase",
    base: "line_of_business",
    materialicons: "confirmation_number",
    submenuItems: [],
  },
  // {
  //   label: "Applicant Submissions",
  //   link: routes.admin_applicant_submissions,
  //   submenu: false,
  //   showSubRoute: false,
  //   icon: "file-check",
  //   base: "line_of_business",
  //   materialicons: "fact_check",
  //   submenuItems: [],
  // },
  {
    // label: "System Settings",
    label: "Account Settings",
    icon: "settings",
    submenu: true,
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "Add Manager",
        link: routes.admin_addManager,
        submenu: false,
        showSubRoute: false,
        base: "add_manager",
      },
      {
        label: "Add Verifier",
        link: routes.admin_addVerifier,
        submenu: false,
        showSubRoute: false,
        base: "add_verifier",
      },
      // {
      //   label: "Manage Verifier",
      //   link: routes.admin_manageVerifier,
      //   submenu: false,
      //   showSubRoute: false,
      //   base: "manage_verifier",
      // },
    ],
  },
  // -------- Master Settings ----------
];

// manager
const ManagerSidebarMenu = [
  // {
  //   label: "Live Case Progress",
  //   link: routes.manager_liveCaseProgress,
  //   submenu: false,
  //   showSubRoute: false,
  //   icon: "activity",
  //   base: "live-track-case",
  //   materialicons: "confirmation_number",
  //   submenuItems: [],
  // },
  {
    label: "HR Action Required",
    link: routes.manager_HRActionRequired,
    submenu: false,
    showSubRoute: false,
    icon: "alert-circle",
    base: "hr-action-required",
    materialicons: "confirmation_number",
    submenuItems: [],
  },
  {
    label: "Case Tracking",
    link: routes.manager_case_tracking,
    submenu: false,
    showSubRoute: false,
    icon: "trending-up",
    base: "hr-action-required",
    materialicons: "timeline",
    submenuItems: [],
  },
  {
    label: "Line of Business",
    link: routes.manager_LobList,
    submenu: false,
    showSubRoute: false,
    icon: "briefcase",
    base: "line_of_business",
    materialicons: "confirmation_number",
    submenuItems: [],
  },
  {
    label: "Account Settings",
    icon: "settings",
    submenu: true,
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "Add Verifier",
        link: routes.manager_addVerifier,
        submenu: false,
        showSubRoute: false,
        base: "add_verifier",
      },
      {
        label: "Manage Verifier",
        link: routes.manager_Verifier,
        submenu: false,
        showSubRoute: false,
        base: "manage_verifier",
      },
    ],
  },
];

// verifier
const VerifierSidebarMenu = [
  {
    label: "Live Case Progress",
    link: routes.verifier_liveCaseProgress,
    submenu: false,
    showSubRoute: false,
    icon: "activity",
    base: "live-track-case",
    materialicons: "confirmation_number",
    submenuItems: [],
  },
  {
    label: "HR Action Required",
    link: routes.verifier_HRActionRequired,
    submenu: false,
    showSubRoute: false,
    icon: "alert-circle",
    base: "hr-action-required",
    materialicons: "confirmation_number",
    submenuItems: [],
  },
  // {
  //   label: "Case Tracking",
  //   link: routes.verifier_case_tracking,
  //   submenu: false,
  //   showSubRoute: false,
  //   icon: "trending-up",
  //   base: "hr-action-required",
  //   materialicons: "timeline",
  //   submenuItems: [],
  // },
];
